<div [style.backgroundImage]="'url('+currentBG+')'"
    class=" h-100 position-relative bg-auth">
    <div class="overlay"></div>
    <div class="h-100 w-100 position-relative d-grid z-4" style="grid-template-rows: 100%;">
        <ng-content ></ng-content>
    </div>
</div>